// extracted by mini-css-extract-plugin
export default {"Courses":"Courses_Courses__sPVXd","headerContainer":"Courses_headerContainer__2L4pM"};